import { defineComponent, onMounted, onUnmounted } from 'vue';
import ErrorModalCode from '@/presentation/components/shared/error-modal/error-modal.code';

export default defineComponent({
	setup: () => {
		const code = new ErrorModalCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			modalContent: code.modalContent,
			errorIsRelatedToInvalidCampaignId: code.errorIsRelatedToInvalidCampaignId,
			errorIsRelatedToGetGeneralCampaignData: code.errorIsRelatedToGetGeneralCampaignData,
			errorIsRelatedToGetAccountManagers: code.errorIsRelatedToGetAccountManagers,
			errorIsRelatedToGetClientServicesPeople: code.errorIsRelatedToGetClientServicesPeople,
			errorIsRelatedToSearchOrganisations: code.errorIsRelatedToSearchOrganisations,
			errorIsRelatedToUnsupportedCampaignSetting: code.errorIsRelatedToUnsupportedCampaignSetting,
			errorIsRelatedToGetCustomProducts: code.errorIsRelatedToGetCustomProducts,
			errorIsRelatedToLoadingGeotargetingWhenStandAlone: code.errorIsRelatedToLoadingGeotargetingWhenStandAlone,
			errorIsRelatedToGetCampaignReadinessInfo: code.errorIsRelatedToGetCampaignReadinessInfo,
			errorIsRelatedToGetCampaignListingEntities: code.errorIsRelatedToGetCampaignListingEntities,
			errorIsRelatedToACustomProductsOnlyCampaignPageView: code.errorIsRelatedToACustomProductsOnlyCampaignPageView,
			errorIsRelatedToGetRightsUsers: code.errorIsRelatedToGetRightsUsers,
			errorIsRelatedToSearchRightsUsers: code.errorIsRelatedToSearchRightsUsers,
			errorIsRelatedToGetAuditorEntries: code.errorIsRelatedToGetAuditorEntries,
			errorIsRelatedToGetPricingProducts: code.errorIsRelatedToGetPricingProducts,
			errorIsRelatedToCreateFailedOnDuplicateEntry: code.errorIsRelatedToCreateFailedOnDuplicateEntry,
			errorIsRelatedToSaveFailedOnDuplicateEntry: code.errorIsRelatedToSaveFailedOnDuplicateEntry,
			invalidCampaignPropertyMessage: code.invalidCampaignPropertyMessage,
			duplicateEntryCampaignDetails: code.duplicateEntryCampaignDetails,
			duplicateEntryStartDateShort: code.duplicateEntryStartDateShort,
			redirectToTheDuplicateEntry: code.redirectToTheDuplicateEntry.bind(code),
			closeModal: code.closeModal.bind(code)
		};
	}
});
